import { useEffect, useState } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Swal from "sweetalert2";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import { hasPermission } from "../../../utils/hasPermissions";
import RowClientActionsMenu from "./RowClientActionsMenu";
import RowSocietyActionsMenu from "./RowSocietyActionsMenu";
import RowCollegeActionsMenu from "./RowCollegeActionsMenu";
import RowUserActionsMenu from "./RowUserActionsMenu";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SchoolIcon from "@mui/icons-material/School";
import { json } from "react-router-dom";
import { Chip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
function Client() {
  const [columns, setColumns] = useState([]);
  const [scolumns, setSColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [srows, setSRows] = useState([]);
  const [crows, setCRows] = useState([]);
  const [ccolumns, setCColumns] = useState([]);
  const [urows, setURows] = useState([]);
  const [ucolumns, setUColumns] = useState([]);
  const [open, setOpen] = useState(false);
  const [sopen, setSocietyOpen] = useState(false);
  const [copen, setCollegeOpen] = useState(false);
  const [uopen, setUserOpen] = useState(false);
  const [dbInstances, setDbInstances] = useState([]);
  const [societyList, setSocietyList] = useState([]);
  const [collegeList, setCollegeList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [editingSociety, setEditingSociety] = useState(null);
  const [formData, setFormData] = useState({
    client_id: "",
    client_name: "",
    client_email: "",
    db_instance_id: "",
    is_client_active: "",
    client_website: "",
    client_url: "",
    client_code: "",
    client_contactno: "",
    client_logo: null, // file object
  });
  const [formErrors, setFormErrors] = useState({});
  const [userformErrors, setUserFormErrors] = useState({});
  const [openSociety, setOpenSociety] = useState(false);
  const [openSocietyData, setOpenSocietyView] = useState(false);
  const [openCollege, setOpenCollege] = useState(false);
  const [openCollegeData, setOpenCollegeView] = useState(false);
  const [openUserData, setOpenUserView] = useState(false);
  const [clientId, setClientId] = useState();
  const [societyId, setSocietyId] = useState();
  const [collegeId, setCollegeId] = useState();
  const [dbinstanceId, setDbinstanceId] = useState();
  const [userId, setUserId] = useState();
  const [clientName, setClientName] = useState();
  const [societyFormData, setSocietyFormData] = useState({
    client_id: "",
    society_name: "",
    db_instance_id: "",
    is_society_active: "",
  });
  const [collegeFormData, setCollegeFormData] = useState({
    society_id: "",
    college_name: "",
    is_college_active: "",
    college_code: "",
    college_refurl: "",
    college_email: "",
    college_validity: "",
    db_instance_id: "",
  });
  const [userFormData, setUserFormData] = useState({
    college_id: "",
    user_name: "",
    user_email: "",
    user_password: "",
    is_user_active: "",
    user_role_id: "",
  });

  const [collegeDialogOpen, setCollegeDialogOpen] = useState(false);
  const [userDialogOpen, setUserDialogOpen] = useState(false);
  const [selectedSociety, setSelectedSociety] = useState(null);

  const [collegeName, setCollegeName] = useState("");
  const [userName, setUserName] = useState("");
  const [societyName, setSocietyName] = useState("");
  const [collegeCode, setCollegeCode] = useState("");

  const ActiveStatusCell = ({ value }) => (
    <Chip
      label={value === "ACTIVE" || value === true || value === 1 ? "Active" : "Inactive"}
      color={value === "ACTIVE" || value === true || value === 1 ? "success" : "error"}
      size="small"
      variant="outlined"
    />
  );
  ActiveStatusCell.propTypes = {
    value: PropTypes.number.isRequired,
  };
  const handleAddCollegeClick = (society) => {
    setSelectedSociety(society);
    setCollegeDialogOpen(true);
  };

  const handleSaveCollege = () => {
    // Save the college data with collegeName, collegeCode, and selectedSociety.society_id
    console.log("Saving college for society:", selectedSociety, {
      collegeName,
      collegeCode,
    });
    // Clear and close
    setCollegeName("");
    setCollegeCode("");
    setCollegeDialogOpen(false);
  };
  const openSocietiesView = async (client_id, client_name, db_instance_id) => {
    setClientId(client_id);
    setDbinstanceId(db_instance_id);
    try {
      const res = await axios.get(`${API_BASE_URL}/api/societies/${client_id}`, {
        headers: getAuthHeaders(),
      });
      setSColumns([
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>SNo</span>,
          accessor: "sno",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Society Name</span>,
          accessor: "society_name",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Active</span>,
          accessor: "is_society_active",
          Cell: ActiveStatusCell,
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Actions</span>,
          accessor: "actions",
          align: "center",
          disableSortBy: true,
        },
      ]);
      const formattedSRows = res.data.map((row, index) => ({
        sno: index + 1,
        ...row,
        db_instance_id,
        actions: (
          <RowSocietyActionsMenu
            row={row}
            db_instance_id={db_instance_id}
            onSocietyEdit={handleSocietyEdit}
            onSocietyDelete={handleSocietyDelete}
            onCreateCollege={openCollegeDialog}
            onViewColleges={openCollegesView}
            hasPermission={hasPermission}
          />
        ),
      }));

      setSRows(formattedSRows);
      setSocietyList(res.data);
      setClientName(client_name);
      setOpenSocietyView(true);
    } catch (error) {
      showSnackbar("Failed to fetch societies", error);
    }
  };
  const openCollegesView = async (client_id, society_id, society_name, db_instance_id) => {
    setClientId(client_id);
    setSocietyId(society_id);
    setSocietyName(society_name);
    try {
      const res = await axios.get(`${API_BASE_URL}/api/colleges/${client_id}/${society_id}`, {
        headers: getAuthHeaders(),
      });
      setCColumns([
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>SNo</span>,
          accessor: "sno",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>College Name</span>,
          accessor: "college_name",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>College Code</span>,
          accessor: "college_code",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Active</span>,
          accessor: "is_college_active",
          Cell: ActiveStatusCell,
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Actions</span>,
          accessor: "actions",
          align: "center",
          disableSortBy: true,
        },
      ]);
      const formattedCRows = res.data.map((row, index) => ({
        sno: index + 1,
        ...row,
        client_id,
        actions: (
          <RowCollegeActionsMenu
            row={row}
            client_id={client_id}
            onCollegeEdit={handleCollegeEdit}
            onCollegeDelete={handleCollegeDelete}
            onCreateUser={openUserDialog}
            onViewUsers={openUsersView}
            hasPermission={hasPermission}
          />
        ),
      }));

      setCRows(formattedCRows);
      setCollegeList(res.data);
      setSocietyName(society_name);
      setOpenCollegeView(true);
    } catch (error) {
      showSnackbar("Failed to fetch societies", error);
    }
  };
  const openUsersView = async (client_id, college_id, college_name, db_instance_id) => {
    setCollegeId(college_id);
    setCollegeName(college_name);
    try {
      const res = await axios.get(`${API_BASE_URL}/api/auth/users-by-college/${college_id}`, {
        headers: getAuthHeaders(),
      });
      setUColumns([
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>SNo</span>,
          accessor: "sno",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>User Email</span>,
          accessor: "user_email",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>User Role</span>,
          accessor: "user_role_id",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Active</span>,
          accessor: "is_user_active",
          Cell: ActiveStatusCell,
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Actions</span>,
          accessor: "actions",
          align: "center",
          disableSortBy: true,
        },
      ]);
      const formattedURows = res.data.map((row, index) => ({
        sno: index + 1,
        ...row,
        actions: (
          <RowUserActionsMenu
            row={row}
            onUserEdit={handleUserEdit}
            onUserDelete={handleUserEdit}
            hasPermission={hasPermission}
          />
        ),
      }));

      setURows(formattedURows);
      setUserList(res.data);
      setCollegeName(college_name);
      setOpenUserView(true);
    } catch (error) {
      showSnackbar("Failed to fetch Users", error);
    }
  };
  const openSocietyDialog = (client_id, client_name, db_instance_id) => {
    setSocietyFormData({
      client_id,
      client_name,
      db_instance_id,
      society_name: "",
      is_society_active: "",
      society_email: "",
      society_code: "",
    });
    setSocietyOpen(true);
    setSocietyEditingId(null);
    setClientId(client_id);
    setClientName(client_name);
  };
  const openCollegeDialog = (client_id, society_id, college_id, db_instance_id) => {
    setCollegeFormData({
      client_id,
      society_id,
      db_instance_id,
      college_name: "",
      is_college_active: "",
      college_email: "",
      college_code: "",
      college_refurl: "",
      college_validity: "",
    });
    setClientId(client_id);
    setSocietyId(society_id);
    setCollegeOpen(true);
    setCollegeEditingId(null);
  };

  const openSocietyView = (client_id, db_instance_id) => {
    setSocietyFormData({
      client_id,
      db_instance_id,
      society_name: "",
      is_society_active: "",
      society_email: "",
      society_code: "",
    });
    setOpenSocietyView(true);
  };
  const openCollegeView = (society_id, client_id, db_instance_id) => {
    setCollegeFormData({
      society_id,
      client_id,
      db_instance_id,
      college_name: "",
      is_college_active: "",
      college_email: "",
      college_code: "",
      college_refurl: "",
      college_validity: "",
    });
    setOpenCollegeView(true);
  };
  const openUserDialog = (client_id, college_id, society_id, db_instance_id) => {
    setUserFormData({
      client_id,
      college_id,
      db_instance_id,
      user_name: "",
      is_user_active: "",
      user_email: "",
      user_password: "",
      user_role_id: "",
    });
    setCollegeId(college_id);
    setUserOpen(true);
  };
  const [editingId, setEditingId] = useState(null);
  const [seditingId, setSocietyEditingId] = useState(null);
  const [ceditingId, setCollegeEditingId] = useState(null);
  const [ueditingId, setUserEditingId] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    fetchClients();
    fetchDbInstances();
  }, []);

  const getAuthHeaders = () => {
    const token = sessionStorage.getItem("token");
    return {
      Authorization: `Bearer ${token}`,
    };
  };

  const fetchDbInstances = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/dbinstances`, {
        headers: getAuthHeaders(),
      });
      setDbInstances(res.data);
    } catch (err) {
      console.error("Error fetching DB instances:", err);
    }
  };

  const fetchClients = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/clients`, {
        headers: getAuthHeaders(),
      });
      setColumns([
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>SNo</span>,
          accessor: "sno",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Client Name</span>,
          accessor: "client_name",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Email</span>,
          accessor: "client_email",
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Active</span>,
          accessor: "is_client_active",
          Cell: ActiveStatusCell,
        },
        {
          Header: () => <span style={{ fontSize: "13px", fontWeight: "bold" }}>Actions</span>,
          accessor: "actions",
          align: "center",
          disableSortBy: true,
        },
      ]);

      const formattedRows = res.data.map((row, index) => ({
        sno: index + 1,
        ...row,
        actions: (
          <RowClientActionsMenu
            row={row}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onCreateSociety={openSocietyDialog}
            onViewSocieties={openSocietiesView}
            hasPermission={hasPermission}
          />
        ),
      }));
      setRows(formattedRows);
    } catch (err) {
      console.error("Fetch clients error:", err);
      showSnackbar("Error fetching client data", "error");
    }
  };

  const handleEdit = (row) => {
    setFormData({ ...row });
    setEditingId(row.client_id);
    setOpen(true);
  };
  const handleSocietyEdit = (row) => {
    setSocietyFormData({ ...row });
    setSocietyName(row.society_name);
    setSocietyEditingId(row.society_id);
    setSocietyOpen(true);
  };
  const handleCollegeEdit = (row) => {
    setCollegeFormData({ ...row });
    setCollegeEditingId(row.college_id);
    setCollegeOpen(true);
  };
  const handleUserEdit = (row) => {
    setUserFormData({ ...row });
    setUserEditingId(row.user_id);
    setUserOpen(true);
  };
  const handleDelete = async (client_id) => {
    const confirm3 = await Swal.fire({
      title: "Sure to delete Client?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      willOpen: () => {
        const container = document.querySelector(".swal2-container");
        if (container) {
          container.style.zIndex = "20000";
        }
      },
    });

    if (confirm3.isConfirmed) {
      let response;
      try {
        response = await axios.post(
          `${API_BASE_URL}/bootstrap-client.php?action=delete&client_id=${client_id}`,
          null,
          {
            headers: getAuthHeaders(),
          }
        );
        if (response.status === 200) {
          showSnackbar(" Client Deleted successfully", "success");
        } else {
          showSnackbar(" Client is not Deleted ", "error");
        }
        fetchClients();
      } catch (err) {
        alert(err);
        showSnackbar("Error deleting Client", "error");
      }
    }
  };
  const handleSocietyDelete = async (society_id) => {
    const confirm2 = await Swal.fire({
      title: "Sure to delete society?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      willOpen: () => {
        const container = document.querySelector(".swal2-container");
        if (container) {
          container.style.zIndex = "20000";
        }
      },
    });

    if (confirm2.isConfirmed) {
      try {
        await axios.post(
          `${API_BASE_URL}/bootstrap-society.php?action=delete&society_id=${society_id}`,
          null,
          {
            headers: getAuthHeaders(),
          }
        );
        showSnackbar(" Society Deleted successfully", "success");
        fetchClients();
      } catch (err) {
        showSnackbar("Error deleting Society", "error");
      }
    }
  };
  const handleCollegeDelete = async (college_id) => {
    const confirm_c = await Swal.fire({
      title: "Sure to delete College?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      willOpen: () => {
        const container = document.querySelector(".swal2-container");
        if (container) {
          container.style.zIndex = "20000";
        }
      },
    });
    if (confirm_c.isConfirmed) {
      try {
        await axios.post(
          `${API_BASE_URL}/bootstrap-college.php?action=delete&college_id=${college_id}`,
          { db_instance_id: dbinstanceId },
          {
            headers: getAuthHeaders(),
          }
        );
        showSnackbar(" College Deleted successfully", "success");
        openCollegesView(college_id);
      } catch (err) {
        showSnackbar("Error deleting College", "error");
      }
    }
  };
  const handleClientSave = async () => {
    const errors = {};

    if (!formData.client_name?.trim()) {
      errors.client_name = "Client name is required";
    }

    if (!formData.client_email?.trim()) {
      errors.client_email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.client_email)) {
      errors.client_email = "Invalid email format";
    }

    if (!formData.client_code?.trim()) {
      errors.client_code = "Client code is required";
    }

    if (!formData.client_contactno?.trim()) {
      errors.client_contactno = "Contact number is required";
    } else if (!/^\d{10,15}$/.test(formData.client_contactno)) {
      errors.client_contactno = "Enter valid contact number";
    }

    if (!formData.db_instance_id) {
      errors.db_instance_id = "Select DB instance";
    }

    if (editingId && formData.is_client_active === "") {
      errors.is_client_active = "Select status";
    }

    setFormErrors(errors);

    if (Object.keys(errors).length > 0) return;
    const user = JSON.parse(sessionStorage.getItem("user"));
    const userName = user?.user_name || "unknown";
    try {
      let response;
      if (editingId) {
        response = await axios.post(
          `${API_BASE_URL}/api/clients/update/${editingId}`,
          {
            client_id: editingId,
            updated_by: userName,
            ...formData,
          },
          {
            headers: getAuthHeaders(),
          }
        );
      } else {
        response = await axios.post(
          `${API_BASE_URL}/api/clients`,
          {
            created_by: userName,
            ...formData,
          },
          {
            headers: getAuthHeaders(),
          }
        );
      }
      if (response.status === 200) {
        alert(response.data.message);
        const { success, message } = response.data;
        showSnackbar(message, "success");
      } else {
        showSnackbar("Something went wrong. Please try again.", "error");
      }
      setOpen(false);
      fetchClients();
    } catch (error) {
      console.error("Error saving:", error);
      showSnackbar("Error saving data", "error");
    }
  };
  const handleSocietySave = async (client_id, society_id) => {
    const errors = {};

    if (!societyFormData.society_name?.trim()) {
      errors.society_name = "Society name is required";
    }

    if (!societyFormData.society_code?.trim()) {
      errors.society_code = "Society code is required";
    }

    if (!societyFormData.society_email?.trim()) {
      errors.society_email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(societyFormData.society_email)) {
      errors.society_email = "Invalid email format";
    }

    if (societyFormData.is_society_active === "") {
      errors.is_society_active = "Select active status";
    }

    setFormErrors(errors);

    if (Object.keys(errors).length > 0) return;
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));
      const userName = user?.user_name || "unknown";
      const payload = {
        ...societyFormData,
        created_by: userName,
        db_instance_id: dbinstanceId,
      };
      let response;
      if (seditingId) {
        response = await axios.put(
          `${API_BASE_URL}/api/societies/${client_id}/${seditingId}`,
          payload,
          {
            headers: getAuthHeaders(),
          }
        );
      } else {
        const { client_name, db_instance_id, ...filteredSocietyData } = societyFormData;
        response = await axios.post(
          `${API_BASE_URL}/api/societies`,
          {
            created_by: userName,
            ...filteredSocietyData,
          },
          {
            headers: getAuthHeaders(),
          }
        );
      }
      if (response.status === 200) {
        const { success, message } = response.data;
        openSocietiesView(clientId, clientName, dbinstanceId);
        showSnackbar(message, "success");
        setSocietyOpen(false);
      } else {
        showSnackbar("Failed to create society", "error");
      }
    } catch (error) {
      console.error("Error creating society:", error);
      showSnackbar("Error occurred during save", "error");
    }
  };
  const handleCollegeSave = async (client_id, society_id, college_id) => {
    const errors = {};
    if (!collegeFormData.college_name?.trim()) {
      errors.college_name = "College name is required";
    }

    if (!collegeFormData.college_code?.trim()) {
      errors.college_code = "College code is required";
    }

    if (collegeFormData.is_college_active === "") {
      errors.is_college_active = "Select active status";
    }
    if (collegeFormData.college_refurl === "") {
      errors.college_refurl = " Referal url is required";
    }
    if (collegeFormData.college_emaill === "") {
      errors.college_email = " Email is required to send GUID-Token";
    }
    if (collegeFormData.college_validity === "") {
      errors.college_validity = "Select validity in months";
    }
    setFormErrors(errors);

    if (Object.keys(errors).length > 0) return;
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));
      const userName = user?.user_name || "unknown";
      const payload = {
        ...collegeFormData,
        created_by: userName,
        client_id: clientId,
        db_instance_id: dbinstanceId,
      };
      let response;
      if (ceditingId) {
        response = await axios.post(`${API_BASE_URL}/api/colleges/${ceditingId}`, payload, {
          headers: getAuthHeaders(),
        });
      } else {
        response = await axios.post(`${API_BASE_URL}/api/colleges`, payload, {
          headers: getAuthHeaders(),
        });
      }
      if (response.status === 200) {
        const { success, message } = response.data;
        openCollegesView(clientId, societyId, societyName, dbinstanceId);
        showSnackbar(message, "success");
        alert("College is Created");
        setCollegeOpen(false);
      } else {
        showSnackbar("Failed to create college", "error");
      }
    } catch (error) {
      console.error("Error creating college:", error);
      showSnackbar("Error occurred during save", "error");
    }
  };
  const handleUserSave = async (client_id, college_id, user_id) => {
    const errors = {};

    if (!userFormData.user_name) {
      errors.user_name = "User Name is required";
    }

    if (!userFormData.user_email) {
      errors.user_email = "User Email is required";
    } else if (!/\S+@\S+\.\S+/.test(userFormData.user_email)) {
      errors.user_email = "Email format is invalid";
    }

    if (!userFormData.user_role_id) {
      errors.user_role_id = "User Role is required";
    }

    if (!userFormData.is_user_active) {
      errors.is_user_active = "Active status is required";
    }

    if (!userFormData.password) {
      errors.password = "Password is required";
    } else if (userFormData.password.length < 6) {
      errors.password = "Password must be at least 6 characters";
    }

    if (!userFormData.confirmPassword) {
      errors.confirmPassword = "Please retype password";
    } else if (userFormData.password !== userFormData.confirmPassword) {
      errors.confirmPassword = "Passwords do not match";
    }

    setUserFormErrors(errors);

    if (Object.keys(errors).length > 0) return;
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));
      const userName = user?.user_name || "unknown";
      const payload = {
        ...userFormData,
        created_by: userName,
        user_role_id: Number(userFormData.user_role_id),
        is_user_active: Number(userFormData.is_user_active),
        client_id: clientId,
        college_id: collegeId,
      };

      let response;
      if (ueditingId) {
        response = await axios.post(`${API_BASE_URL}/api/auth/add-user/${ueditingId}`, payload, {
          headers: getAuthHeaders(),
        });
      } else {
        response = await axios.post(`${API_BASE_URL}/api/auth/add-user`, payload, {
          headers: getAuthHeaders(),
        });
      }
      if (response.status === 200) {
        alert(response.data.message);
        const { success, message } = response.data;
        openUsersView(clientId, collegeId, societyName, collegeName);
        showSnackbar(message, "success");
        setUserOpen(false);
      } else {
        showSnackbar("Failed to create User", "error");
      }
    } catch (error) {
      console.error("Error creating user:", error);
      showSnackbar("Error occurred during save", "error");
    }
  };
  const handleEditSociety = (society) => {
    setSocietyFormData(society);
    setEditingSociety(society.society_id); // assuming `society_id` is the unique key
    setOpenSociety(true); // reuse existing form dialog
  };
  const handleSocietyDelete2 = async (society_id) => {
    if (confirm("Do you want to delete Society??")) {
      try {
        await axios.post(
          `${API_BASE_URL}/bootstrap-society.php?action=delete&society_id=${society_id}`,
          null,
          {
            headers: getAuthHeaders(),
          }
        );
        showSnackbar("Society is deleted", "success");
        openSocietyView(societyFormData.client_id); // refresh list
      } catch (error) {
        showSnackbar("Failed to delete Society", "error");
      }
    }
  };
  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={1}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDBox display="flex" justifyContent="space-between" alignItems="center">
                  <MDTypography variant="h6" color="white">
                    CLIENTS MANAGEMENT
                  </MDTypography>
                  {hasPermission("create") && (
                    <MDButton
                      variant="contained"
                      color="info"
                      onClick={() => {
                        setOpen(true);
                        setFormData({});
                        setEditingId(null);
                      }}
                    >
                      <Icon>add</Icon> Add New Client {hasPermission("create")}
                    </MDButton>
                  )}
                </MDBox>
              </MDBox>
              <MDBox pt={2}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  entriesPerPage={true}
                  showTotalEntries={true}
                  canSearch={true}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={() => setSnackbarOpen(false)}>
        <MuiAlert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          elevation={6}
          variant="filled"
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>
          {editingId ? "Edit Client" : "Add Client"}
          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "#ff4444",
              transition: "transform 0.2s ease-in-out",
              "&:hover": {
                transform: "scale(1.2)",
                color: "#d32f2f",
                backgroundColor: "rgba(255,255,255,0.2)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TextField
            label="Client Name"
            margin="dense"
            fullWidth
            value={formData.client_name || ""}
            onChange={(e) => setFormData({ ...formData, client_name: e.target.value })}
            error={!!formErrors.client_name}
            helperText={formErrors.client_name}
          />

          <TextField
            label="Client Email"
            margin="dense"
            fullWidth
            value={formData.client_email || ""}
            onChange={(e) => setFormData({ ...formData, client_email: e.target.value })}
            error={!!formErrors.client_email}
            helperText={formErrors.client_email}
          />

          <TextField
            label="Website"
            margin="dense"
            fullWidth
            value={formData.client_website || ""}
            onChange={(e) => setFormData({ ...formData, client_website: e.target.value })}
          />

          <TextField
            label="Client URL"
            margin="dense"
            fullWidth
            value={formData.client_url || ""}
            onChange={(e) => setFormData({ ...formData, client_url: e.target.value })}
          />

          <TextField
            label="Client Code"
            margin="dense"
            fullWidth
            value={formData.client_code || ""}
            onChange={(e) => setFormData({ ...formData, client_code: e.target.value })}
            error={!!formErrors.client_code}
            helperText={formErrors.client_code}
          />

          <TextField
            label="Contact No"
            margin="dense"
            fullWidth
            value={formData.client_contactno || ""}
            onChange={(e) => setFormData({ ...formData, client_contactno: e.target.value })}
            error={!!formErrors.client_contactno}
            helperText={formErrors.client_contactno}
          />

          <TextField
            label="DB Instance"
            margin="dense"
            select
            fullWidth
            InputLabelProps={{ shrink: true }}
            SelectProps={{ native: true, displayEmpty: true }}
            value={formData.db_instance_id || ""}
            onChange={(e) => setFormData({ ...formData, db_instance_id: e.target.value })}
            error={!!formErrors.db_instance_id}
            helperText={formErrors.db_instance_id}
          >
            <option value="" disabled hidden>
              Select DB Instance
            </option>
            {dbInstances.map((db) => (
              <option key={db.db_instance_id} value={db.db_instance_id}>
                {db.db_instance_name}-{db.db_instance_type}
              </option>
            ))}
          </TextField>

          {editingId && (
            <TextField
              label="Is Active"
              margin="dense"
              select
              fullWidth
              value={formData.is_client_active || ""}
              onChange={(e) => setFormData({ ...formData, is_client_active: e.target.value })}
              SelectProps={{ native: true }}
              error={!!formErrors.is_client_active}
              helperText={formErrors.is_client_active}
            >
              <option value="">Select Status</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </TextField>
          )}
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setOpen(false)} color="error">
            Cancel
          </MDButton>
          <MDButton onClick={handleClientSave} color="info">
            Save Client
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={sopen} onClose={() => setSocietyOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          {seditingId ? "Edit Society of " : "Add Society for "}
          {clientName}
          <IconButton
            onClick={() => setSocietyOpen(false)}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "#ff4444",
              transition: "transform 0.2s ease-in-out",
              "&:hover": {
                transform: "scale(1.2)",
                color: "#d32f2f",
                backgroundColor: "rgba(255,255,255,0.2)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TextField
            label="Society Name"
            fullWidth
            required
            type="text"
            margin="normal"
            value={societyFormData.society_name}
            onChange={(e) =>
              setSocietyFormData({ ...societyFormData, society_name: e.target.value })
            }
            error={!!formErrors.society_name}
            helperText={formErrors.society_name}
          />

          <TextField
            label="Society Code"
            fullWidth
            required
            type="text"
            margin="normal"
            value={societyFormData.society_code}
            onChange={(e) =>
              setSocietyFormData({ ...societyFormData, society_code: e.target.value })
            }
            error={!!formErrors.society_code}
            helperText={formErrors.society_code}
          />

          <TextField
            label="Society Email"
            fullWidth
            required
            type="email"
            margin="normal"
            value={societyFormData.society_email}
            onChange={(e) =>
              setSocietyFormData({ ...societyFormData, society_email: e.target.value })
            }
            error={!!formErrors.society_email}
            helperText={formErrors.society_email}
          />

          <TextField
            label="Is Active"
            margin="dense"
            required
            select
            fullWidth
            InputLabelProps={{ shrink: true }}
            SelectProps={{ native: true, displayEmpty: true }}
            value={societyFormData.is_society_active || ""}
            onChange={(e) =>
              setSocietyFormData({ ...societyFormData, is_society_active: e.target.value })
            }
            error={!!formErrors.is_society_active}
            helperText={formErrors.is_society_active}
          >
            <option value="" disabled hidden>
              Select Status
            </option>
            <option value="1">Yes</option>
            <option value="0">No</option>
          </TextField>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setSocietyOpen(false)} color="error">
            Cancel
          </MDButton>
          <MDButton onClick={handleSocietySave} variant="contained" color="info">
            Save Society
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openSocietyData}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            setOpenSocietyView(false);
          }
        }}
        fullWidth
        maxWidth={false} // Disable built-in width
        sx={{
          "& .MuiDialog-paper": {
            width: "80%",
            maxWidth: "none",
            zIndex: 2000,
          },
        }}
      >
        <DialogTitle>
          Societies List of {clientName}
          <IconButton
            onClick={() => setOpenSocietyView(false)}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "#ff4444",
              transition: "transform 0.2s ease-in-out",
              "&:hover": {
                transform: "scale(1.2)",
                color: "#d32f2f",
                backgroundColor: "rgba(255,255,255,0.2)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            background: "linear-gradient(to bottom,hsl(270, 8.80%, 86.70%),rgb(182, 205, 244))", // Gradient background for DialogContent
            padding: 2,
          }}
        >
          <MDBox pt={2}>
            <DataTable
              table={{ columns: scolumns, rows: srows }}
              isSorted={true}
              entriesPerPage={true}
              showTotalEntries={true}
              canSearch={true}
              noEndBorder
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            color="success"
            onClick={() => setOpenSocietyView(false)}
            sx={{
              background: "linear-gradient(45deg,rgb(239, 43, 21),rgb(224, 73, 31))",
              color: "#fff",
              "&:hover": {
                background: "linear-gradient(45deg,rgb(210, 77, 25),rgb(242, 122, 53))",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={copen} onClose={() => setCollegeOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          {ceditingId ? "Edit College of " : "Add College to"}
          {societyName}
        </DialogTitle>
        <DialogContent>
          <TextField
            label="College Name"
            fullWidth
            required
            type="text"
            margin="normal"
            value={collegeFormData.college_name}
            onChange={(e) =>
              setCollegeFormData({ ...collegeFormData, college_name: e.target.value })
            }
            error={!!formErrors.college_name}
            helperText={formErrors.college_name}
          />

          <TextField
            label="College Code"
            fullWidth
            required
            type="text"
            margin="normal"
            value={collegeFormData.college_code}
            onChange={(e) =>
              setCollegeFormData({ ...collegeFormData, college_code: e.target.value })
            }
            error={!!formErrors.college_code}
            helperText={formErrors.college_code}
          />
          <TextField
            label="College Email"
            fullWidth
            required
            type="email"
            margin="normal"
            value={collegeFormData.college_email}
            onChange={(e) =>
              setCollegeFormData({ ...collegeFormData, college_email: e.target.value })
            }
            error={!!formErrors.college_email}
            helperText={formErrors.college_email}
          />
          <TextField
            label="College Referal URL"
            fullWidth
            required
            type="url"
            margin="normal"
            value={collegeFormData.college_refurl}
            onChange={(e) =>
              setCollegeFormData({ ...collegeFormData, college_refurl: e.target.value })
            }
            error={!!formErrors.college_refurl}
            helperText={formErrors.college_refurl}
          />
          <TextField
            label="Validity in months"
            margin="dense"
            required
            select
            fullWidth
            InputLabelProps={{ shrink: true }}
            SelectProps={{ native: true, displayEmpty: true }}
            value={collegeFormData.college_validity || ""}
            onChange={(e) =>
              setCollegeFormData({ ...collegeFormData, college_validity: e.target.value })
            }
            error={!!formErrors.college_validity}
            helperText={formErrors.college_validity}
          >
            <option value="" disabled hidden>
              Select Validity in months
            </option>
            <option value="3">3 Months</option>
            <option value="6">6 Months</option>
            <option value="12">12 Months</option>
            <option value="24">24 Months</option>
          </TextField>
          <TextField
            label="Is Active"
            margin="dense"
            required
            select
            fullWidth
            InputLabelProps={{ shrink: true }}
            SelectProps={{ native: true, displayEmpty: true }}
            value={collegeFormData.is_college_active || ""}
            onChange={(e) =>
              setCollegeFormData({ ...collegeFormData, is_college_active: e.target.value })
            }
            error={!!formErrors.is_college_active}
            helperText={formErrors.is_college_active}
          >
            <option value="" disabled hidden>
              Select Status
            </option>
            <option value="1">Yes</option>
            <option value="0">No</option>
          </TextField>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setCollegeOpen(false)} color="error">
            Cancel
          </MDButton>
          <MDButton onClick={handleCollegeSave} variant="contained" color="info">
            Save College
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openCollegeData}
        onClose={() => setOpenCollegeView(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Colleges List of {societyName}</DialogTitle>
        <DialogContent
          sx={{
            background: "linear-gradient(to bottom,hsl(270, 8.80%, 86.70%),rgb(182, 205, 244))", // Gradient background for DialogContent
            padding: 2,
          }}
        >
          <MDBox pt={2}>
            <DataTable
              table={{ columns: ccolumns, rows: crows }}
              isSorted={true}
              entriesPerPage={true}
              showTotalEntries={true}
              canSearch={true}
              noEndBorder
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            color="success"
            onClick={() => setOpenCollegeView(false)}
            sx={{
              background: "linear-gradient(45deg,rgb(239, 43, 21),rgb(224, 73, 31))",
              color: "#fff",
              "&:hover": {
                background: "linear-gradient(45deg,rgb(210, 77, 25),rgb(242, 122, 53))",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openUserData} onClose={() => setOpenUserView(false)} fullWidth maxWidth="md">
        <DialogTitle>Users List of {collegeName}</DialogTitle>
        <DialogContent
          sx={{
            background: "linear-gradient(to bottom,hsl(270, 8.80%, 86.70%),rgb(182, 205, 244))", // Gradient background for DialogContent
            padding: 2,
          }}
        >
          <MDBox pt={2}>
            <DataTable
              table={{ columns: ucolumns, rows: urows }}
              isSorted={true}
              entriesPerPage={true}
              showTotalEntries={true}
              canSearch={true}
              noEndBorder
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            color="success"
            onClick={() => setOpenUserView(false)}
            sx={{
              background: "linear-gradient(45deg,rgb(239, 43, 21),rgb(224, 73, 31))",
              color: "#fff",
              "&:hover": {
                background: "linear-gradient(45deg,rgb(210, 77, 25),rgb(242, 122, 53))",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={uopen}
        onClose={() => setUserOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: { zIndex: 2000 }, // set your desired z-index
        }}
      >
        <DialogTitle>{ueditingId ? "Edit User" : "Add User"}</DialogTitle>
        <DialogContent>
          <TextField
            label="User Name"
            fullWidth
            required
            type="text"
            margin="normal"
            value={userFormData.user_name}
            onChange={(e) => setUserFormData({ ...userFormData, user_name: e.target.value })}
            error={!!userformErrors.user_name}
            helperText={userformErrors.user_name}
          />

          <TextField
            label="User Email"
            fullWidth
            required
            type="email"
            margin="normal"
            value={userFormData.user_email}
            onChange={(e) => setUserFormData({ ...userFormData, user_email: e.target.value })}
            error={!!userformErrors.user_email}
            helperText={userformErrors.user_email}
          />

          <TextField
            label="User Role"
            margin="dense"
            required
            select
            fullWidth
            InputLabelProps={{ shrink: true }}
            SelectProps={{ native: true, displayEmpty: true }}
            value={userFormData.user_role_id || ""}
            onChange={(e) => setUserFormData({ ...userFormData, user_role_id: e.target.value })}
            error={!!userformErrors.user_role_id}
            helperText={userformErrors.user_role_id}
          >
            <option value="" disabled hidden>
              Select Role
            </option>
            <option value="1">System-Admin</option>
            <option value="2">Client-Admin</option>
          </TextField>

          <TextField
            label="Is Active"
            margin="dense"
            required
            select
            fullWidth
            InputLabelProps={{ shrink: true }}
            SelectProps={{ native: true, displayEmpty: true }}
            value={userFormData.is_user_active || ""}
            onChange={(e) => setUserFormData({ ...userFormData, is_user_active: e.target.value })}
            error={!!userformErrors.is_user_active}
            helperText={userformErrors.is_user_active}
          >
            <option value="" disabled hidden>
              Select Status
            </option>
            <option value="1">Yes</option>
            <option value="0">No</option>
          </TextField>

          <TextField
            label="Password"
            fullWidth
            required
            type="password"
            margin="normal"
            value={userFormData.password}
            onChange={(e) => setUserFormData({ ...userFormData, password: e.target.value })}
            error={!!userformErrors.password}
            helperText={userformErrors.password}
          />

          <TextField
            label="Retype Password"
            fullWidth
            required
            type="password"
            margin="normal"
            value={userFormData.confirmPassword}
            onChange={(e) => setUserFormData({ ...userFormData, confirmPassword: e.target.value })}
            error={!!userformErrors.confirmPassword}
            helperText={userformErrors.confirmPassword}
          />
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setUserOpen(false)} color="error">
            Cancel
          </MDButton>
          <MDButton onClick={handleUserSave} variant="contained" color="info">
            Save User
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}
export default Client;
